export const EVIDENCE_AUDIT_HEADERS = [
  'Audit',
  'Date Range',
  'Includes Evidence',
  'Set to Audit Start Date',
  'Set to Audit End Date',
]
